import type { AuthAction, AuthState, AuthUser } from '../types/auth';

export const initialAuthState: AuthState = {
  apiCode: localStorage.getItem('apiCode') || undefined,
  apiUrl: null,
  apiVersion: null,
  env: JSON.parse(localStorage.getItem('env') || JSON.stringify({ parameters: {}, settings: {}, pagesTexts: {} })),
  features: {},
  hasLogout: false,
  isAuthenticated: false,
  isDevicePaired: false,
  isInitialized: false,
  socketUrl: localStorage.getItem('socketUrl') || undefined,
  sockets: Object.values(JSON.parse(localStorage.getItem('sockets') || '{}')),
  user: null
};

export function authReducer(state: AuthState, action: AuthAction): AuthState {
  switch (action.type) {
    case 'INITIALIZE': {
      const { apiVersion, apiCode, apiUrl, env, features, isAuthenticated, isDevicePaired, sockets, socketUrl, user } =
        action.payload;
      return {
        ...state,
        apiVersion,
        apiCode: apiCode ?? state.apiCode,
        apiUrl,
        env,
        features,
        hasLogout: false,
        isAuthenticated,
        isDevicePaired,
        isInitialized: true,
        sockets,
        socketUrl: socketUrl ?? state.socketUrl,
        user: user || ({} as AuthUser)
      };
    }
    case 'LOGIN': {
      const { socketUrl, isDevicePaired, user, apiUrl } = action.payload;
      return {
        ...state,
        isAuthenticated: true,
        isDevicePaired,
        hasLogout: false,
        socketUrl: socketUrl ?? state.socketUrl,
        apiUrl,
        user: user || ({} as AuthUser)
      };
    }
    case 'LOGOUT': {
      const { hasLogout, socketUrl } = action.payload;
      return {
        ...state,
        isAuthenticated: false,
        hasLogout,
        socketUrl: socketUrl ?? state.socketUrl,
        apiUrl: hasLogout ? null : state.apiUrl,
        user: null
      };
    }
    case 'SET_USER': {
      const { user } = action.payload;
      return { ...state, user };
    }
    default:
      return state;
  }
}
